"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rsaEncrypt = require("@/utils/rsaEncrypt");

var _settings = _interopRequireDefault(require("@/settings"));

var _login = require("@/api/login");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _qs = _interopRequireDefault(require("qs"));

var _logo = _interopRequireDefault(require("@/assets/images/logo3.jpg"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Login',
  data: function data() {
    return {
      Background: _logo.default,
      codeUrl: '',
      cookiePass: '',
      loginForm: {
        username: '',
        password: '',
        rememberMe: false,
        code: '',
        uuid: ''
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          message: '用户名不能为空'
        }],
        password: [{
          required: true,
          trigger: 'blur',
          message: '密码不能为空'
        }],
        code: [{
          required: true,
          trigger: 'change',
          message: '验证码不能为空'
        }]
      },
      loading: false,
      redirect: undefined
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        var data = route.query;

        if (data && data.redirect) {
          this.redirect = data.redirect;
          delete data.redirect;

          if (JSON.stringify(data) !== '{}') {
            this.redirect = this.redirect + '&' + _qs.default.stringify(data, {
              indices: false
            });
          }
        }
      },
      immediate: true
    }
  },
  created: function created() {
    // 获取验证码
    this.getCode(); // 获取用户名密码等Cookie

    this.getCookie(); // token 过期提示

    this.point();
  },
  methods: {
    getCode: function getCode() {
      var _this = this;

      (0, _login.getCodeImg)().then(function (res) {
        _this.codeUrl = res.img;
        _this.loginForm.uuid = res.uuid;
      });
    },
    getCookie: function getCookie() {
      var username = _jsCookie.default.get('username');

      var password = _jsCookie.default.get('password');

      var rememberMe = _jsCookie.default.get('rememberMe'); // 保存cookie里面的加密后的密码


      this.cookiePass = password === undefined ? '' : password;
      password = password === undefined ? this.loginForm.password : password;
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
        code: ''
      };
    },
    handleLogin: function handleLogin() {
      var _this2 = this;

      this.$refs.loginForm.validate(function (valid) {
        var user = {
          username: _this2.loginForm.username,
          password: _this2.loginForm.password,
          rememberMe: _this2.loginForm.rememberMe,
          code: _this2.loginForm.code,
          uuid: _this2.loginForm.uuid
        };

        if (user.password !== _this2.cookiePass) {
          user.password = (0, _rsaEncrypt.encrypt)(user.password);
        }

        if (valid) {
          _this2.loading = true;

          if (user.rememberMe) {
            _jsCookie.default.set('username', user.username, {
              expires: _settings.default.passCookieExpires
            });

            _jsCookie.default.set('password', user.password, {
              expires: _settings.default.passCookieExpires
            });

            _jsCookie.default.set('rememberMe', user.rememberMe, {
              expires: _settings.default.passCookieExpires
            });
          } else {
            _jsCookie.default.remove('username');

            _jsCookie.default.remove('password');

            _jsCookie.default.remove('rememberMe');
          }

          _this2.$store.dispatch('Login', user).then(function () {
            _this2.loading = false;

            _this2.$router.push({
              path: _this2.redirect || '/'
            });
          }).catch(function () {
            _this2.loading = false;

            _this2.getCode();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    point: function point() {
      var point = _jsCookie.default.get('point') !== undefined;

      if (point) {
        this.$notify({
          title: '提示',
          message: '当前登录状态已过期，请重新登录！',
          type: 'warning',
          duration: 5000
        });

        _jsCookie.default.remove('point');
      }
    }
  }
};
exports.default = _default;